import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import {
  FDClickableText,
  FDPaper, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import Collapse from '@mui/material/Collapse';
import useMobileLayout from 'Hooks/useMobileLayout';

export const Offer = ({ onChoose }) => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);
  const chooseSelf = useCallback(async () => {
    setLoading(true);
    try {
      await onChoose(resource);
    } finally {
      setLoading(false);
    }
  }, [onChoose, resource]);
  return (
    <FDPaper appearance="elevated" padding={isMobile ? 2 : 3} flex={1} maxWidth={isMobile ? undefined : '50%'}>
      <FDStack direction="column" spacing={1}>
        <MetaControlField attr="headline" />
        <MetaControlField attr="headlineFinePrint" />
        <Collapse in={expanded}>
          <div>
            <MetaControlField attr="details" />
          </div>
        </Collapse>
        <FDStack direction="column" spacing={2}>
          <FDPrimaryActionButton
            label="Claim offer"
            onClick={chooseSelf}
            loading={loading}
          />
          <FDClickableText
            appearance="minor"
            label={expanded ? 'Hide details' : 'View details'}
            onClick={() => setExpanded(val => !val)}
          />
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};

Offer.propTypes = {
  onChoose: PropTypes.func.isRequired,
};
